export default __webpack_public_path__ + "static/item_05-40b2ab15b3057ec73de6a2d6e339f78b.jpg";